import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";

const store = {
  namespaced: true,
  state: {
    kelas: null,
    grouping: null
  },
  getters: {
    kelas(state) {
      return state.kelas;
    },
    grouping(state) {
      return state.grouping;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    jenjang({}, { instansi_id, diklat_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/jenjang${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getKelasku({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/kelasku${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getInstruktur({}, { instansi_id, diklat_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/instruktur`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getTema({}, tema_id) {
      return axios
        .get(`${M_API}/temamodul/${tema_id}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    form(_, { instansi_id, diklat_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    visibleKelas(_, { jenis, obj }) {
      obj.is_visible = jenis == 1 ? 1 : 0;
      return axios
        .put(`${M_API}/instansi/${obj.instansi_id}/diklat/${obj.diklat_id}/kelas/${obj.id}`, obj)
        .then(res => {
          return res;
        })
        .catch(e => e);
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios
        .delete(`${API}/api/instansi/${item.instansi_id}/diklat/${item.diklat_id}/kelas/${item.id}`)
        .then(res => {
          return res.data;
        });
    },

    // eslint-disable-next-line
    unggahRekaman({}, { instansi_id, obj }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/rekaman`, obj)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
        hapusRekaman({}, { instansi_id, id }) {
          return axios
            .delete(`${M_API}/instansi/${instansi_id}/rekaman/${id}`)
            .then(res => {
              return res.data;
            })
            .catch(err => Promise.reject(err));
        },

    // eslint-disable-next-line
    syncCourse({}, { instansi_id, kelas_id }) {
      return axios
        .post(`${M_API}/instansi/${instansi_id}/kelas/${kelas_id}/sync_course`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    syncModul({}, object) {
      return axios
        .post(`${M_API}/instansi/${object.instansi_id}/diklat/${object.diklat_id}/kelas/${object.id}/syncmodul`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    getGrup({ state }, { instansi_id, diklat_id, kelas_id }) {
      var _url = `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul`;
      return axios
        .get(_url)
        .then(res => {
          state.grouping = res.data;
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    addGrouping({}, { instansi_id, diklat_id, kelas_id, kelas_modul_id, obj }) {
      return axios
        .post(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping`,
          obj
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    dropGrouping({}, { instansi_id, diklat_id, kelas_id, kelas_modul_id, grouping_id }) {
      return axios
        .delete(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping/${grouping_id}
          }`
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    addGroup({}, { instansi_id, diklat_id, kelas_id, kelas_modul_id, grouping_id, obj }) {
      return axios
        .post(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping/${grouping_id}/grup`,
          obj
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    dropGroup({}, { instansi_id, diklat_id, kelas_id, kelas_modul_id, grouping_id, obj }) {
      return axios
        .delete(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping/${grouping_id}/grup/${
            obj.id
          }`
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    getKandidatGrup({}, { instansi_id, diklat_id, kelas_id, kelas_modul_id, grouping_id, group_id, params }) {
      var _url = `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping/${grouping_id}/grup/${group_id}/kandidat`;
      return axios
        .get(`${_url}${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    formKandidat(_, { instansi_id, diklat_id, kelas_id, kelas_modul_id, grouping_id, group_id, obj }) {
      return axios
        .post(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping/${grouping_id}/grup/${group_id}/member`,
          obj
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    },

    dropKandidat(_, { instansi_id, diklat_id, kelas_id, kelas_modul_id, grouping_id, group_id, obj }) {
      return axios
        .post(
          `${M_API}/instansi/${instansi_id}/diklat/${diklat_id}/kelas/${kelas_id}/kelasmodul/${kelas_modul_id}/gruping/${grouping_id}/grup/${group_id}/unmember`,
          obj
        )
        .then(res => {
          return res;
        })
        .catch(e => e);
    }
  }
};

export default store;
